import {gsap} from "gsap";
import {HTH} from "../HTH";
import {HTHGameConfig} from "../HTHGameConfig";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {HTHGameAssets} from "../HTHGameAssets";
import {HTHHelper} from "../utils/HTHHelper";
import {ISymbolData, HTHSymbol, HTHSymbolStates} from "./HTHSymbol";

export class HTHXSplitSymbol extends HTHSymbol {

    private _xsSpine: PIXI.spine.Spine
    private _spineContainer: PIXI.Container;
    private _bg: PIXI.Sprite;
    private _frame: PIXI.Sprite;
    // private _sprite: PIXI.Sprite;
    private _multiplierText: PIXI.BitmapText;

    constructor(symbolData: ISymbolData, state: HTHSymbolStates = HTHSymbolStates.NORMAL) {
        super(symbolData, state);
        this.init(HTHSymbolStates.NORMAL);

    }

    public get spine(): PIXI.spine.Spine {
        return this._xsSpine;
    }

    public animationChange(animName: string): gsap.core.Timeline {
        return HTHHelper.playSpineWithTimeline(this._xsSpine, 0, animName);
    }

    public spriteChange(): gsap.core.Timeline {
        const chnageTl: gsap.core.Timeline = gsap.timeline();
        chnageTl.to(this._xsSpine, {duration: 0.7, alpha: 0});
        return chnageTl;
    }

    public removeAndDestroy(): void {
        if (this._multiplierText) {
            this.removeChild(this._multiplierText);
            this._multiplierText.destroy();
        }
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }


    /*  public animDuration(animName: string): number {
          return HTHHelper.spineAnimDuration(this._spine, animName);
      }*/

    public init(initState: HTHSymbolStates): HTHXSplitSymbol {
        this.addSpine();
        this._multiplierText = new PIXI.BitmapText("", {
            fontName: HTHGameAssets.BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER,
            fontSize: 12,
            letterSpacing: -35
        });
        this.addChild(this._multiplierText);
        this._multiplierText.alpha = 0;
        this._multiplierText.position.set(0, 27);
        this._multiplierText.anchor = new PIXI.Point(0.5, 0)
        this.symbolState = initState;
        return this;
    }

    public makeBgvisible(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.to([this._bg, this._frame], {alpha: 1, duration: 0.25});
        return tl;
    }

    public remove(): void {
        /* if (this._spine) {
             this._spine.destroy();
         }*/
        if (this._xsSpine) {
            this._xsSpine.destroy();
        }
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.destroy({children: true});
        this.isRemoved = true;
    }

    public addSymbolMultiplier(): void {
        if (this.symSize > 1) {
            this._multiplierText.alpha = 1
            this._multiplierText.position.set(0, 27);
            this._multiplierText.anchor = new PIXI.Point(0.5, 0)
            this.updateSymbolMultiplier(this.symSize);
        }

    }

    public updateSymbolMultiplier(value: number): void {
        this._multiplierText.text = `x${value}`;
        this._multiplierText.maxWidth = 30;
    }

    public removeSymbolMultiplier(): void {
        this.removeChild(this._multiplierText);
        this._multiplierText.destroy();
    }

    public addSplitEffect(size: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        this.symSize = this.symSize * 2;
        tl.add(this.splitMultiplier(size * 2));

        this.symbolState = HTHSymbolStates.NORMAL;
        return tl;
    }

    public splitMultiplier(size: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        let orangeMulti: PIXI.BitmapText = new PIXI.BitmapText("", {
            fontName: HTHGameAssets.BITMAP_FONT_SYMBOL_SIZE_MULTIPLIER,
            fontSize: 12,
            tint: 0xFFA500,
            letterSpacing: -35
        });

        tl.add(() => {
            this._multiplierText.addChild(orangeMulti);
            this._multiplierText.alpha = 1;
            orangeMulti.anchor = new PIXI.Point(0.5, 0);
            orangeMulti.alpha = 0;
            orangeMulti.text = this._multiplierText.text;
        }, 0)

        if (this.symSize > 1) {
            tl.to(this._multiplierText.scale, {x: 0.9, y: 0.9, duration: 0.333});
            tl.to(this._multiplierText.scale, {x: 1.4, y: 1.4, duration: 0.033});
            tl.add(() => {
                this._multiplierText.text = `x${size}`;
                orangeMulti.text = this._multiplierText.text;
                this._multiplierText.position.set(0, 27);
                this._multiplierText.anchor = new PIXI.Point(0.5, 0);
                this._multiplierText.maxWidth = 25;
            }, ">");
            tl.to(orangeMulti, {alpha: 1, duration: 0.001});
            tl.to(orangeMulti, {alpha: 0, duration: 0.165});

            tl.to([this._multiplierText.scale], {x: 0.9, y: 0.9, duration: 0.132}, "<")
            tl.to([this._multiplierText.scale], {x: 1, y: 1, duration: 0.033});
            tl.add(() => {
                this.removeChild(orangeMulti);
                orangeMulti.destroy();
            })

        }
        return tl;
    }

    protected addSpine(): void {
        /*    if (this._spine) {
                return;
            }
            this._spine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("XS"));
            //this.animationChange("xsplit");
            this._spine.visible = false;*/
        this._spineContainer = new PIXI.Container();
        this._bg = new PIXI.Sprite(HTH.assetLoader.getTextures("W/W_BG")[0]);
        this._bg.anchor.set(0.5, 0.5);
        this._bg.alpha = 0;
        this._frame = new PIXI.Sprite(HTH.assetLoader.getTextures("Frames/Frame")[0]);
        this._frame.anchor.set(0.5, 0.5);
        this._frame.alpha = 0;
        this._xsSpine = new PIXI.spine.Spine(HTH.assetLoader.getSpineAsset("XS"));
        this._xsSpine.state.setAnimation(0, "idle", false);
        this._spineContainer.addChild(this._bg, this._frame, this._xsSpine);
        this.addChild(/*this._spine,*/this._spineContainer);
        if(this.reelId>0 && this.reelId<5 && this.id===3){
            this._xsSpine.position.y+=1;
        }

    }

}